import { get ,post} from "./baseService";

export async function getSchools() {
  const response = await get("schools", true);
  return response;
}

export async function getSchool(code) {
  const response = await get(`schools/${code}`, true);
  return response;
}

export async function getSchoolFormationFilter(code) {
  const response = await get(`schools/formation/${code}`, true);
  return response;
}

export async function getSchoolFormationFilterResult(code) {
  const response = await get(`schools/formation/${code.code}?filter=${code.filterName}`, true);
  return response;
}



export async function getCountrySchool(code) {
  const response = await get(`countries/${code}/schools`, true);
  return response;
}

export async function getOtherSchool(data) {
  const response = await post("schools/latlong", data, true);
  return response;
}

export async function getFormationsBySearch() {
  const response = await get("formations", true);
  return response;
}

export function addUniversityInStudentFavoriteList(data) {
  return post('users/add-favorite', data, true).then(response=>response)
}
export function getStudentFavoriteUniversityList(data) {
  return post('users/get-favorite', data, true).then(response=>response)
}
export function getStudentFavoriteOpportunityList(data) {
  return post('users/get-favorite', data, true).then(response=>response)
}
export function deleteStudentFavoriteUniversity(data) {
  return post('users/delete-favorite', data, true).then(response=>response)
}
export function deleteStudentFavoriteOpportunity(data) {
  return post('users/delete-favorite', data, true).then(response=>response)
}
export function getAllOpportunities(data) {
  return post('get-all-opportunities', data, true).then(response=>response)
}